// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3OJ77","imageUploader":"EGiftCard_imageUploader__3vvRV"};